import { render, staticRenderFns } from "./DictationCreate.vue?vue&type=template&id=57c6ba13&scoped=true&"
import script from "./DictationCreate.vue?vue&type=script&lang=js&"
export * from "./DictationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c6ba13",
  null
  
)

export default component.exports